export const STATIONS_STATE = 'STATIONS';

export const MARKER_HEIGHT = 72;
export const MARKER_WIDTH = 72;

export const ACTIVE_MARKER_HEIGHT = 152;
export const ACTIVE_MARKER_WIDTH = 152;

export const CLUSTER_HEIGHT = 128;
export const CLUSTER_WIDTH = 128;

export const LARGEST_CLUSTER_HEIGHT = 128;
export const LARGET_CLUSTER_WIDTH = 186;

export const MIN_LARGE_CLUSTER_WEIGHT = 1000;

export const STATIONS_PRICE_REPORTS_URL_PARAM = 'service-points-price-report';

export const STATIONS_DISPLAY_RADIUS = {
  min: 0.5, // km.
  max: 15
};